import { useEffect, useState } from 'react';

/* useOSPulse — privacy-safe live snapshot of the KITXENS AI OS.
   Polls /api/pulse every 90s. Returns null until first load. */

let _cache = null;
let _fetchedAt = 0;

export function useOSPulse(pollMs = 90000) {
  const [pulse, setPulse] = useState(_cache);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/pulse`);
        if (!r.ok) return;
        const data = await r.json();
        _cache = data;
        _fetchedAt = Date.now();
        if (alive) setPulse(data);
      } catch {
        /* silent — the site never breaks because of the pulse */
      }
    };
    if (!_cache || Date.now() - _fetchedAt > pollMs) load();
    const t = setInterval(load, pollMs);
    return () => { alive = false; clearInterval(t); };
  }, [pollMs]);

  return pulse;
}

export function timeAgo(iso, es) {
  if (!iso) return '';
  const s = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return es ? 'hace unos segundos' : 'moments ago';
  const m = Math.floor(s / 60);
  if (m < 60) return es ? `hace ${m} min` : `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return es ? `hace ${h} h` : `${h}h ago`;
  const d = Math.floor(h / 24);
  return es ? `hace ${d} d` : `${d}d ago`;
}

export function eventLabel(e, es) {
  const t = e.title ? `«${e.title.length > 55 ? e.title.slice(0, 55) + '…' : e.title}»` : '';
  switch (e.type) {
    case 'ARTICLE_PUBLISHED':
      return es ? `Penny publicó ${t}` : `Penny published ${t}`;
    case 'SOCIAL_PACKAGE_READY':
      return es ? `Sonny preparó el paquete social de ${t}` : `Sonny prepared the social package for ${t}`;
    case 'RSS_UPDATED':
      return es ? 'Feed de distribución actualizado' : 'Distribution feed updated';
    case 'POST_PUBLISHED':
      return es ? `Post publicado en ${e.source}` : `Post published on ${e.source}`;
    case 'CAMPAIGN_CREATED':
      return es ? 'Sonny lanzó una campaña multicanal' : 'Sonny launched a multi-channel campaign';
    case 'NEWSLETTER_SUBSCRIBED':
      return es ? 'Nuevo suscriptor al Technology Brief' : 'New Technology Brief subscriber';
    case 'LEAD_CREATED':
      return es ? 'Nuevo restaurante interesado en Kitxens' : 'New restaurant reached out to Kitxens';
    default:
      return e.type;
  }
}
